export default "__VITE_ASSET__266f8924__"